(() => {
  document.querySelectorAll('[data-np7-home]').forEach((root) => {
    if (root.dataset.np7Ready === 'true') return;
    root.dataset.np7Ready = 'true';

    const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const setVideoState = (video) => {
      const toggle = video.closest('figure')?.querySelector('[data-np7-video-toggle]');
      if (!toggle) return;
      const icon = toggle.querySelector('span');
      const isPlaying = !video.paused && !video.ended;
      toggle.setAttribute('aria-label', isPlaying ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
      if (icon) icon.textContent = isPlaying ? 'Ⅱ' : '▶';
    };
    const lazyVideos = [...root.querySelectorAll('[data-np7-lazy-video]')];
    const loadVideo = (video) => {
      const source = video.querySelector('source[data-src]');
      if (source && !source.getAttribute('src')) {
        source.src = source.dataset.src;
        video.load();
      }
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      setVideoState(video);
    };
    const pauseOtherVideos = (activeVideo) => {
      lazyVideos.forEach((video) => {
        if (video !== activeVideo && !video.paused) video.pause();
      });
    };
    const playVideo = (video, userInitiated = false) => {
      loadVideo(video);
      if (motionPreference.matches && !userInitiated) {
        video.pause();
        setVideoState(video);
        return;
      }
      if (userInitiated) pauseOtherVideos(video);
      const playAttempt = video.play();
      if (playAttempt && typeof playAttempt.then === 'function') {
        playAttempt.then(() => setVideoState(video)).catch(() => setVideoState(video));
      }
      setVideoState(video);
    };

    lazyVideos.forEach((video) => {
      video.addEventListener('play', () => setVideoState(video));
      video.addEventListener('pause', () => setVideoState(video));
      video.addEventListener('ended', () => setVideoState(video));
    });
    if ('IntersectionObserver' in window) {
      const loadObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadVideo(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '300px 0px', threshold: 0.01 });
      const playbackObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          const isPlaybackVisible = entry.isIntersecting && entry.intersectionRatio >= 0.45;
          if (isPlaybackVisible && video.hasAttribute('data-np7-autoplay')) {
            playVideo(video);
          } else if (!isPlaybackVisible && !video.paused) {
            video.pause();
          }
        });
      }, { threshold: [0, 0.45] });
      lazyVideos.forEach((video) => {
        loadObserver.observe(video);
        playbackObserver.observe(video);
      });
    } else {
      lazyVideos.forEach((video) => loadVideo(video));
      if (!motionPreference.matches) {
        lazyVideos.filter((video) => video.hasAttribute('data-np7-autoplay')).forEach((video) => playVideo(video));
      }
    }

    const handleMotionChange = (event) => {
      if (!event.matches) return;
      lazyVideos.forEach((video) => {
        video.removeAttribute('autoplay');
        video.pause();
        setVideoState(video);
      });
    };
    if (motionPreference.matches) handleMotionChange(motionPreference);
    if (typeof motionPreference.addEventListener === 'function') motionPreference.addEventListener('change', handleMotionChange);
    else if (typeof motionPreference.addListener === 'function') motionPreference.addListener(handleMotionChange);

    const nativeProof = root.querySelector('.np7-home__native-proof');
    const nativeProofContainer = nativeProof?.querySelector('[data-fera-container="product_reviews"]');
    if (nativeProof && nativeProofContainer) {
      let proofObserver;
      const syncNativeProof = () => {
        if (!nativeProofContainer.querySelector('.fera-productReviews')) return false;
        const normalizeFeraRating = () => {
          const rating = nativeProofContainer.querySelector('.fera-productReviews-avgRating-val');
          if (rating?.textContent.trim() === '5.0') rating.textContent = '5';
        };
        normalizeFeraRating();
        window.setTimeout(normalizeFeraRating, 250);
        nativeProof.classList.add('is-loaded');
        proofObserver?.disconnect();
        return true;
      };
      if (!syncNativeProof()) {
        proofObserver = new MutationObserver(syncNativeProof);
        proofObserver.observe(nativeProofContainer, { childList: true, subtree: true });
      }
    }

    root.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-np7-video-toggle]');
      if (toggle) {
        const video = toggle.closest('figure')?.querySelector('video');
        if (!video) return;
        if (video.paused) {
          playVideo(video, true);
        } else {
          video.pause();
          setVideoState(video);
        }
      }
    });

    const finder = root.querySelector('[data-np7-finder]');
    if (finder) {
      const choices = [...finder.querySelectorAll('[data-np7-finder-choice]')];
      const results = [...finder.querySelectorAll('[data-np7-finder-result]')];
      choices.forEach((choice) => {
        choice.addEventListener('click', () => {
          const target = choice.dataset.np7FinderChoice;
          choices.forEach((item) => item.setAttribute('aria-pressed', String(item === choice)));
          results.forEach((result) => {
            const active = result.dataset.np7FinderResult === target;
            result.hidden = !active;
            result.classList.toggle('is-active', active);
          });
        });
      });
    }

    const sticky = root.querySelector('[data-np7-sticky]');
    const hero = root.querySelector('[data-np7-hero]');
    const closing = root.querySelector('[data-np7-closing]');
    if (!sticky || !hero || !closing || !('IntersectionObserver' in window)) return;

    let heroVisible = true;
    let closingVisible = false;
    const renderSticky = () => {
      sticky.classList.toggle('is-visible', !heroVisible && !closingVisible);
    };
    const heroObserver = new IntersectionObserver(([entry]) => {
      heroVisible = entry.isIntersecting;
      renderSticky();
    }, { threshold: 0.08 });
    const closingObserver = new IntersectionObserver(([entry]) => {
      closingVisible = entry.isIntersecting;
      renderSticky();
    }, { threshold: 0.08 });
    heroObserver.observe(hero);
    closingObserver.observe(closing);
    });
})();
